import React, { useState } from 'react';
import Slider from 'react-slick';
import './Home.css';
import logo from '../image/AlinaLogo1.gif';

// Add your carousel images
import carousel1 from '../image/carousel1.jpeg';
import carousel2 from '../image/carousel2.jpeg'; // Add more if available
import carousel3 from '../image/carousel2.jpg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Home = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you! For your interest, we shall inform you at ${email} when we launch.`);
    setEmail('');
  };

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // 2 seconds gap
    arrows: false,
    pauseOnHover: false,
  };

  return (
    <div className="coming-soon-container">
      {/* Carousel Background */}
      <Slider {...carouselSettings} className="carousel-slider">
        <div>
          <img src={carousel1} alt="Slide1" className="carousel-image" />
        </div>
        <div>
          <img src={carousel2} alt="Slide2" className="carousel-image" />
        </div>
        <div>
          <img src={carousel3} alt="Slide3" className="carousel-image" />
        </div>
      </Slider>

      {/* Overlay Content */}
      <div className="overlay-content">
        <img src={logo} loading="lazy" className="logos" alt="alina-diagnostic-logo" />

        <h1 className="animated-heading">
          {'Coming Soon...'.split('').map((char, index) => (
            <span key={index} style={{
              animationDelay: `${index * 0.05}s`,
              animationIterationCount: "infinite",
            }}>
              {char}
            </span>
          ))}
        </h1>

        <p className='mail'>
          For more information contact us on&nbsp;
          <a href="mailto:info@alinadiagnostics.com" style={{ color: 'white' }}>
            <span>info@alinadiagnostics.com</span>
          </a>
        </p>


        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email address..."
            required
          />
          <button type="submit">NOTIFY ME !</button>
        </form>
      </div>
    </div>
  );
};

export default Home;
